module.exports = {"name":"Vyhľadávanie osoby","icon":"<i class='material-icons'>people</i>","widget":[{"type":"person-search","head":["Meno","Priezvisko","Registračné číslo","Pohlavie","Národnosť"],"cols":[["baseData.name.v"],["baseData.surName.v"],["baseData.registrationID"],["baseData.gender"],["baseData.nationality"]],"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/person-search/person-search.json
// module id = 380
// module chunks = 0